import React from "react";
import { StyleSheet, View, Image } from "react-native";

import t from "@constants/localization";
import colors from "@constants/color";
import Text from "@components/CustomText";

const ItemCard = ({ short_name, quantity, product_image, amount }) => {
  const PATH = "screens/MyTask";
  return (
    <View>
      <View key={`${short_name}-${quantity}`} style={styles.itemContainer}>
        <Image
          source={{ uri: product_image }}
          style={styles.itemImage}
          resizeMode="cover"
          alt="Product Image"
        />
        <View style={styles.itemDescContainer}>
          <Text newfont variant="body_text_3">
            {short_name}
          </Text>
          <View style={styles.descContainer}>
            <Text newfont variant="body_text_1">
              {t(`${PATH}/rs`)}
              <Text
                newfont
                variant="body_text_1"
                style={{ fontFamily: "NotoSansDevanagari-Bold" }}
              >
                {amount}
              </Text>
            </Text>
            <View style={styles.itemDescSeparator} />
            <Text newfont variant="body_text_1">
              Qty •{" "}
              <Text
                newfont
                variant="body_text_1"
                style={{ fontFamily: "NotoSansDevanagari-Bold" }}
              >
                {quantity}
              </Text>
            </Text>
          </View>
        </View>
      </View>
    </View>
  );
};

export default ItemCard;
const styles = StyleSheet.create({
  itemContainer: {
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 8,
    paddingHorizontal: 16,
  },
  itemImage: {
    height: 60,
    width: 60,
  },
  itemDescContainer: {
    paddingHorizontal: 16,
    width: "80%",
  },
  itemDescSeparator: {
    backgroundColor: colors.lightMediumBlack,
    height: 22,
    width: 1,
    marginHorizontal: 16,
  },
  descContainer: {
    flexDirection: "row",
    alignItems: "center",
    paddingTop: 2,
  },
});
